import { render, staticRenderFns } from "./NotificationModalContent.vue?vue&type=template&id=79174fe4&scoped=true"
import script from "./NotificationModalContent.vue?vue&type=script&lang=ts"
export * from "./NotificationModalContent.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModalContent.vue?vue&type=style&index=0&id=79174fe4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79174fe4",
  null
  
)

export default component.exports